import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";

/**
 * Tenant-wide billing status hook. Polled on mount, after a successful
 * checkout, and shared with the trial banner + /billing page.
 */
export function useBillingStatus() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/billing/status");
      setData(data);
    } catch { /* unauthenticated/initial */ }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { billing: data, loading, refresh };
}
